// import React from "react";
// import '../styles/ApplicationApproach.css';
// import { InView } from 'react-intersection-observer';

// const ApplicationApproach = () => {

//     return (
//         <section className="application-section">
//             <div className="application-container">
//                 <InView triggerOnce={true} threshold={0.1}>
//                     {({ inView, ref }) => (
//                         <div ref={ref} className={`application-content ${inView ? 'animate' : ''}`}>
//                             <h1>Our Modernization Approach</h1>
//                             <p> We choose the right modernization path based on your needs and minimize disruption to your business.</p>
//                             <div className="colored-boxes">
//                                 <InView triggerOnce={true} threshold={0.1}>
//                                     {({ inView, ref }) => (
//                                         <article ref={ref} className={`colored-box box1 ${inView ? 'animate' : ''}`}>
//                                             <h3>Replacing with a Modern Solution</h3>
//                                             <p>When legacy systems are hard to maintain or scale, replacement is often the practical choice. We deliver secure, cloud-native applications built for the future.</p>
//                                         </article>
//                                     )}
//                                 </InView>
//                                 <InView triggerOnce={true} threshold={0.1}>
//                                     {({ inView, ref }) => (
//                                         <article ref={ref} className={`colored-box box2 ${inView ? 'animate' : ''}`}>
//                                             <h3>Gradual Modernization</h3>
//                                             <p>We modernize your applications in phases.
// This reduces risk, delivers quick improvements, and keeps your current systems running during the transition.</p>
//                                         </article>
//                                     )}
//                                 </InView>
//                                 <InView triggerOnce={true} threshold={0.1}>
//                                     {({ inView, ref }) => (
//                                         <article ref={ref} className={`colored-box box3 ${inView ? 'animate' : ''}`}>
//                                             <h3>Rebuilding in the Cloud</h3>
//                                             <p>We rebuild existing applications using cloud-native architectures to improve performance, scalability, and security.</p>
//                                         </article>
//                                     )}
//                                 </InView>
//                             </div>
//                         </div>
//                     )}
//                 </InView>
//             </div>
//         </section>
//     );
// };

// export default ApplicationApproach;













import React, { useEffect } from "react";
import '../styles/ApplicationApproach.css';

const ApplicationApproach = () => {
    const steps = [
        {
            phase: "Phase 01: Audit",
            title: "Software Debt Assessment",
            desc: "We perform deep static analysis of your application code to identify complexity and performance bottlenecks. Our goal is a precision surgical plan for software modernization.",
            tags: ["Code Audit", "Debt Mapping"],
            color: "green"
        },
        {
            phase: "Phase 02: Refactor",
            title: "Microservices Transition",
            desc: "We re-architect monolithic logic into independent, scalable microservices. This enables individual feature scaling and eliminates the single point of failure in your app core.",
            tags: ["Decoupling", "API Mesh"],
            color: "purple"
        },
        {
            phase: "Phase 03: Velocity",
            title: "Continuous Delivery Modernization",
            desc: "Transition from manual shipments to fully automated app release cycles. We focus on modernizing your developer experience to ensure you ship value to users instantly.",
            tags: ["CI/CD Flow", "GitOps"],
            color: "blue"
        }
    ];

    // Optional: Enables the mouse-tracking "Refractive Shine" effect from your CSS
    useEffect(() => {
        const handleMouseMove = (e) => {
            const cards = document.querySelectorAll('.roadmap-card');
            cards.forEach(card => {
                const rect = card.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;
                card.style.setProperty('--mouse-x', `${x}px`);
                card.style.setProperty('--mouse-y', `${y}px`);
            });
        };
        window.addEventListener('mousemove', handleMouseMove);
        return () => window.removeEventListener('mousemove', handleMouseMove);
    }, []);

    return (
        <section className="section-roadmap" id="approach">
            <div className="container">
                <div className="section-header text-center">
                    <h2 className="section-tag">ENGINEERING PATHWAY</h2>
                    <h3>Our Modernization Strategy</h3>
                </div>

                <div className="roadmap-vertical-flow">
                    {/* The animated S-Curve center line */}
                    <div className="vertical-connector"></div>

                    {steps.map((step, index) => (
                        <div key={index} className="roadmap-step-v">
                            <div className="step-indicator">0{index + 1}</div>
                            <div className={`roadmap-card card-${step.color}`}>
                                <div className="step-tag">{step.phase}</div>
                                <h4>{step.title}</h4>
                                <p>{step.desc}</p>
                                <div className="card-side-tags">
                                    {step.tags.map(tag => (
                                        <span key={tag} className={`side-chip chip-${step.color}`}>{tag}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ApplicationApproach;